import isMobile from '../lib/isMobile';

const mobile = isMobile();

// PHAT
const fluxDefaults = {
    gravity: mobile ? 8 : 14,
    particleScale: mobile ? 1.1 : 0.8,
    // particlesRadius: mobile ? 0.16 : 0.12,
    particlesRadius: mobile ? 0.17 : 0.12,
    initialTicks: mobile ? 200 : 200,
};
// LOW
// const fluxDefaults = {
//     gravity: mobile ? 4 : 4,
//     particleScale: mobile ? 0.6 : 0.48,
//     particlesRadius: mobile ? 0.1 : 0.07,
//     initialTicks: mobile ? 200 : 200,
// };

export default fluxDefaults;



// WEBPACK FOOTER //
// ./js/flux/defaultsLarge.js